import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ASSETS_BASE_URL } from '../../config';

const ImageBoxCard = ({
    img = `${ASSETS_BASE_URL}/ImageBoxes/imageBox.jpg`, // Default image if none provided
    title = "Home",
    href = "#",
    external = false,
    onClick = null
}) => {
    const navigate = useNavigate();
    const fallbackImg = `${ASSETS_BASE_URL}/ImageBoxes/imageBox.jpg`; // Change this to your real fallback image
    const [imgSrc, setImgSrc] = useState(img);

    const handleImageError = () => {
        if (imgSrc !== fallbackImg) setImgSrc(fallbackImg);
    };

    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick();
            return;
        }
        if (!href) return;
        if (external) {
            window.open(href, "_blank", "noopener,noreferrer");
        } else {
            navigate(href);
        }
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '10px',
                boxShadow: '0 0 6px 1px rgba(0,0,0,0.1)',
                width: '250px',
                height: '250px',
                overflow: 'hidden',
                transition: 'transform 0.1s ease-in-out',
                cursor: href ? 'pointer' : 'default',
                '&:hover': {
                    boxShadow: '0 0 6px 1px rgba(0,0,0,0.2)',
                    transform: 'scale(1.02)',
                },
            }}
        >
            {/* Image Box */}
            <Box
                sx={{
                    width: '100%',
                    height: '205px',
                    overflow: 'hidden',
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px',
                }}
            >
                <Box
                    component="img"
                    src={imgSrc}
                    alt={title}
                    onError={handleImageError}
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.1s ease-in-out',
                        '&:hover': {
                            transform: href ? 'scale(1.01)' : 'none',
                        },
                    }}
                />
            </Box>

            {/* Title Box */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '45px',
                    px: 1,
                    backgroundColor: '#fff',
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        width: '100%',
                        textAlign: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2, // ✅ Allows up to 2 lines before ellipsis
                        WebkitBoxOrient: 'vertical',
                        textTransform: 'uppercase',
                        lineHeight: 1.2,
                        fontWeight: "bold",
                    }}
                >
                    {title}
                </Typography>
            </Box>
        </Box>
    );
};

export default ImageBoxCard;
